export default __webpack_public_path__ + "c68c37f26e4bc77fb0a419315af76826.svg";